
<form #verifyOtpForm="ngForm">
  <div class="otp-container">
    <div>
      <ngx-otp-input [config]="otpInputConfig" (otpChange)="handleOtpChange($event)" (fill)="handleFillEvent($event)">
      </ngx-otp-input>
    </div>
    <div class="resendOtp">
      <p>Didn’t receive the code?
        <span class="resend" [ngClass]="{'disableResend': !isResendAllowed}" (click)="resendOTP()">Resend it</span>
        <span *ngIf="!isResendAllowed"> ({{remainingTime | minuteSeconds}})</span>
      </p>
    </div>
  </div>
</form>
<!-- action -->
<app-form-navigation-buttons [form]="verifyOtpForm" [userProfile]="userProfile" [isValid]="isValid"></app-form-navigation-buttons>
